import React from "react";
import {
  CardContent,
  Typography,
  Box,
  Stack,
  Tooltip,
  IconButton,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlineOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import BusinessIcon from "@mui/icons-material/Business";
import StatusChip from "../common/StatusChip";
import { StyledCard } from "../common/StyledCard";
import InfoRow from "../common/InfoRow";
import { BranchSummaryDto } from "../../shared/dtos/branch/BranchSummaryDto";

interface BranchCardProps {
  branch: BranchSummaryDto;
  onView?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
}

const BranchCard: React.FC<BranchCardProps> = ({
  branch,
  onView,
  onEdit,
  onDelete,
}) => (
  <StyledCard>
    <CardContent>
      <Stack
        direction="row"
        sx={{ justifyContent: "space-between", alignItems: "flex-start" }}
      >
        <Box>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {branch.name}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            CODE: {branch.branchCode}
          </Typography>
        </Box>
        <Stack direction="row">
          {onView && (
            <Tooltip title="View Details">
              <IconButton onClick={onView} size="small" color="info">
                <VisibilityOutlinedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
          {onEdit && (
            <Tooltip title="Edit Branch">
              <IconButton onClick={onEdit} size="small" color="secondary">
                <EditOutlinedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
          {onDelete && (
            <Tooltip title="Delete Branch">
              <IconButton onClick={onDelete} size="small" color="error">
                <DeleteOutlineIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Stack>
      </Stack>
      <Stack spacing={1.5} sx={{ mt: 2 }}>
        <InfoRow
          icon={<BusinessIcon fontSize="small" />}
          label="Email"
          value={branch.contactEmail}
        />
        <InfoRow
          icon={<BusinessIcon fontSize="small" />}
          label="Phone"
          value={branch.contactPhone}
        />
        <StatusChip
          status={branch.status}
          icon={<CheckCircleIcon fontSize="small" />}
        />
      </Stack>
    </CardContent>
  </StyledCard>
);

export default BranchCard;
